import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import { Helmet } from "react-helmet"
import { Route } from '../AppRoute';

import { doChangeCategory } from '../../actions/categoryAction';

class PageSelectedCategory extends React.Component {
  constructor(props) {
    super(props);
    const { category } = this.props.match.params;
    if (category !== this.props.dataCategory.selected) {
      // this.props.doChangeCategory(newCategory);
      const categoryUrl = ["streetwear", "fashion", "apparel"].includes(category) ? "apparels" : ["lifestyle", "toys", "electronics-collectibles"].includes(category) ? "lifestyles" : category === "luxury" ? "handbags" : category;
      this.props.doChangeCategory(categoryUrl);
    }
  }

  componentDidUpdate(prevProps) {
    const { category } = this.props.match.params;
    if (prevProps.match.params.category !== category) {
      // if(category !== this.props.dataCategory.selected)
      // this.props.doChangeCategory(category);
      const categoryUrl = ["streetwear", "fashion", "apparel"].includes(category) ? "apparels" : ["lifestyle", "toys", "electronics-collectibles"].includes(category) ? "lifestyles" : category == "luxury" ? "handbags" : category;
      if (category !== this.props.dataCategory.selected) {
        this.props.doChangeCategory(categoryUrl);
      }
      window.scroll({
        behavior: 'smooth',
        top: 0
      })
    }
  }

  _renderMetaTag = () => {
    const { category } = this.props.match.params;
    const isHandbag = category === "luxury"
    const title = isHandbag ? "Kick Avenue - Authentic Luxury" : "Kick Avenue - Authentic Collectibles"
    const meta_description = isHandbag
      ? "Choose from Wide Variety of Brands from Our Largest Designer Collections. Buy Now!"
      : "Your trusted source to buy/sell sneakers and streetwear, discover Air Jordan, Supreme, OFF-WHITE and many more!"

    return (
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content={meta_description}
          data-react-helmet="true"
        />
      </Helmet>
    )
  }

  render() {
    return (
      <div>
        {this._renderMetaTag()}
        <Switch>
          {this.props.routes.map((route, i) => {
            return <Route key={i} {...route} />
          })}
        </Switch>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dataCategory: state.dataCategory
});

const mapDispatchToProps = dispatch => ({
  doChangeCategory: (payload) => dispatch(doChangeCategory(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(PageSelectedCategory);